import { generateUuidV4 } from 'reactApp/utils/helpers';

export const DATA_LIST_BREADCRUMBS_ID = generateUuidV4();
export const DATA_LIST_EXTRABLOCKS_ID = generateUuidV4();
export const DATA_LIST_STORIES_WIDGET_ID = generateUuidV4();
export const DATA_LIST_LAST_FILES_WIDGET_ID = generateUuidV4();
export const DATA_LIST_GALLERY_TAB_MENU_ID = generateUuidV4();
export const DATA_LIST_PUBLIC_UPLOAD_HEADER_ID = generateUuidV4();
export const SAFE_FAKEDOOR_ID = generateUuidV4();
export const FAMILY_DOCUMENTS_FAKEDOOR_ID = generateUuidV4();
